import React from "react";

function Seperator(props) {
  return (
    <div className="flex py-10 items-center">
      <div className="flex-grow border-t border-gray-300"></div>
      <span className="flex-shrink mx-4 text-gray-500 uppercase text-sm font-bold">
        {props.label ?? "OR"}
      </span>
      <div className="flex-grow border-t border-gray-300"></div>
    </div>
  );
}

export default Seperator;
